import type {
  GetPinnedMessagesInput,
  PinChatInput,
  PinChatResponse,
  PinnedMessageItem,
  UnpinChatInput,
} from "shared/types/chat";
import { axiosClient } from "utilz/axios";
import { apiErrorHandler } from "utilz/helpers";

const BASE_URL = import.meta.env.VITE_APP_CHAT_BASE_URL;

export const pinChatMessage = async ({
  chatId,
  type,
  excerpt,
}: PinChatInput): Promise<PinChatResponse> => {
  try {
    const url = `${BASE_URL}/api/chats/${chatId}/pin`;
    const response = await axiosClient.post(url, { type, excerpt });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error(resData?.message);
  } catch (error) {
    throw error;
  }
};

export const unpinChatMessage = async ({
  chatId,
  type,
}: UnpinChatInput): Promise<PinChatResponse> => {
  try {
    const url = `${BASE_URL}/api/chats/${chatId}/pin?type=${type}`;
    const response = await axiosClient.delete(url);
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error(resData?.message);
  } catch (error) {
    throw error;
  }
};

export const getPinnedMessages = async ({
  serviceId,
  type,
}: GetPinnedMessagesInput): Promise<PinnedMessageItem[]> => {
  try {
    const url = `${BASE_URL}/api/chats/pins/${type}?service_id=${serviceId}`;
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success) {
      return resData.data?.resourcePins;
    }
    throw response;
  } catch (error: any) {
    return apiErrorHandler(error);
  }
};
